import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';
import { CustomRulePostRequest, CustomRulePostResponse, CustomRuleGetResponseData } from '../../initiate-and-release/Models/CreateCustomRule/CreateCustomRule';

@Injectable({
    providedIn: 'root'
})
export class CustomRuleInitiateAndReleaseService {
    mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

    constructor(
        private headersService: HeadersService,
        private baseService: BaseRestService,
        private integrationService: IntegrationService
    ) { }

    callCreateCustomRulesPost(request: CustomRulePostRequest): Observable<CustomRulePostResponse> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/custom-rules';
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1'); 
        return this.baseService.post<CustomRulePostRequest, CustomRulePostResponse>(serviceUrl, headers,request,true);
  }

  callCreateCustomRulesGet(): Observable<CustomRuleGetResponseData[]> {
    const serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/custom-rules';
    const headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Schwab-Client-FirmId'] = this.integrationService.currentContext?.firmId?.toString();

    return this.baseService.requestJsonApiListWithMetadata(
      serviceUrl,
      headers,
      null,
      'GET'
    );
  }

   callCustomRulesDelete(ruleId: string | undefined): Observable<null> {
        const url = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + `/v1/custom-rules/${ruleId}`;
        const headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
        return this.baseService.request(url, headers, null, 'DELETE', false);
    }
}
